module.exports = __webpack_public_path__ + "img/25_50.80f45195.png";